// Bob50

const FREQUENCY = 'frequency';
const FREQUENCY_VALUE = 'frequencyValue';
const DEFAULT_ACCOUNTING_FREQUENCY = 'MONTHLY';
const DEFAULT_ACCOUNTING_FREQUENCY_VALUE = '1';

const DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_FOR_JOURNAL = 'OD'; // OD or VEN
const DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_JOURNAL_NAME = 'OD';
const DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_GROUP_POSTING = '0';
const DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_JOURNAL_CLIENT_ACCOUNT_REF = 'lease.name';
const DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_JOURNAL_GENERAL_ACCOUNT_REF = 'lease.name';
const DEFAULT_ACCOUNTING_BOB50_EXPORT_FINANCE_JOURNAL_NAME = 'BANK';
const DEFAULT_ACCOUNTING_BOB50_EXPORT_FINANCIAL_JOURNAL_GENERAL_ACCOUNT_REF = 'bankAccount.id';
const DEFAULT_ACCOUNTING_BOB50_EXPORT_FINANCIAL_JOURNAL_CLIENT_ACCOUNT_REF = 'lease.name';
const DEFAULT_ACCOUNTING_BOB50_EXPORT_FINANCIAL_JOURNAL_SUPPLIER_ACCOUNT_REF = 'contact.id';

export const INTEGRATION_CONFIG_BOB50_FREQUENCY = FREQUENCY;
export const INTEGRATION_CONFIG_BOB50_FREQUENCY_VALUE = FREQUENCY_VALUE;
export const INTEGRATION_CONFIG_BOB50_EXPORT_RENT_FOR_JOURNAL = 'exportRenForJournal';
export const INTEGRATION_CONFIG_BOB50_EXPORT_RENT_JOURNAL_NAME = 'rentJournalName';
export const INTEGRATION_CONFIG_BOB50_EXPORT_FINANCE_JOURNAL_NAME = 'financeJournalName';
export const INTEGRATION_CONFIG_BOB50_EXPORT_RENT_GROUP_POSTING = 'rentJournalGroupPostingByTopClass';
// eslint-disable-next-line max-len
export const INTEGRATION_CONFIG_BOB50_EXPORT_RENT_JOURNAL_CLIENT_ACCOUNT_REF = 'rentJournalClientAccountFieldRef'; // TACCOUNT 400x
// eslint-disable-next-line max-len
export const INTEGRATION_CONFIG_BOB50_EXPORT_RENT_JOURNAL_GENERAL_ACCOUNT_REF = 'rentJournalGeneralAccountFieldRef'; // TACCOUNT 700x
export const INTEGRATION_CONFIG_BOB50_EXPORT_FINANCIAL_JOURNAL_GENERAL_ACCOUNT_REF =
  'financialJournalGeneralAccountFieldRef'; // TACCOUNT 550x
export const INTEGRATION_CONFIG_BOB50_EXPORT_FINANCIAL_JOURNAL_CLIENT_ACCOUNT_REF =
  'financialJournalClientAccountFieldRef'; // TACCOUNT 400x
export const INTEGRATION_CONFIG_BOB50_EXPORT_FINANCIAL_JOURNAL_SUPPLIER_ACCOUNT_REF =
  'financialJournalSupplierAccountFieldRef'; // TACCOUNT 440x
export const INTEGRATION_CONFIG_BOB50_EXPORT_RESULT_RECIPIENTS = 'recipients';

export const bob50DefaultConfigurations = {
  [INTEGRATION_CONFIG_BOB50_FREQUENCY]: DEFAULT_ACCOUNTING_FREQUENCY,
  [INTEGRATION_CONFIG_BOB50_FREQUENCY_VALUE]: DEFAULT_ACCOUNTING_FREQUENCY_VALUE,
  [INTEGRATION_CONFIG_BOB50_EXPORT_RENT_FOR_JOURNAL]: DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_FOR_JOURNAL,
  [INTEGRATION_CONFIG_BOB50_EXPORT_RENT_JOURNAL_NAME]: DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_JOURNAL_NAME,
  [INTEGRATION_CONFIG_BOB50_EXPORT_RENT_GROUP_POSTING]: DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_GROUP_POSTING,
  [INTEGRATION_CONFIG_BOB50_EXPORT_RENT_JOURNAL_CLIENT_ACCOUNT_REF]:
    DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_JOURNAL_CLIENT_ACCOUNT_REF,
  [INTEGRATION_CONFIG_BOB50_EXPORT_RENT_JOURNAL_GENERAL_ACCOUNT_REF]:
    DEFAULT_ACCOUNTING_BOB50_EXPORT_RENT_JOURNAL_GENERAL_ACCOUNT_REF,
  [INTEGRATION_CONFIG_BOB50_EXPORT_FINANCE_JOURNAL_NAME]: DEFAULT_ACCOUNTING_BOB50_EXPORT_FINANCE_JOURNAL_NAME,
  [INTEGRATION_CONFIG_BOB50_EXPORT_FINANCIAL_JOURNAL_GENERAL_ACCOUNT_REF]:
    DEFAULT_ACCOUNTING_BOB50_EXPORT_FINANCIAL_JOURNAL_GENERAL_ACCOUNT_REF,
  [INTEGRATION_CONFIG_BOB50_EXPORT_FINANCIAL_JOURNAL_CLIENT_ACCOUNT_REF]:
    DEFAULT_ACCOUNTING_BOB50_EXPORT_FINANCIAL_JOURNAL_CLIENT_ACCOUNT_REF,
  [INTEGRATION_CONFIG_BOB50_EXPORT_FINANCIAL_JOURNAL_SUPPLIER_ACCOUNT_REF]:
    DEFAULT_ACCOUNTING_BOB50_EXPORT_FINANCIAL_JOURNAL_SUPPLIER_ACCOUNT_REF,
  [INTEGRATION_CONFIG_BOB50_EXPORT_RESULT_RECIPIENTS]: '',
};
